/**
 * Арабское множественное число — 6 форм CLDR (zero, one, two, few, many, other), таблицей,
 * как остальные числа сайта (без Intl: у старых браузеров данных локали может не быть).
 *
 *   0 → zero · 1 → one · 2 → two · 3–10, 103–110 … → few · 11–99, 111–199 … → many
 *   100, 101, 102, 200 …, дробные → other
 *
 * Для словарей в коде фич, где у арабского свои формы: «3 نقاط», «11 نقطة», «100 نقطة».
 * Когда число стоит отдельно от слова (на чипе, в строке «у вас N …»), формы one/two — то же
 * слово, что other: «1 أسبوع», «2 أسبوع» (так в арабском iPhone: «متبقي %lld يوم»).
 */
export type ArabicPluralCategory = "zero" | "one" | "two" | "few" | "many" | "other";

export type ArabicPluralForms = Partial<Record<ArabicPluralCategory, string>> & { other: string };

export const arabicPluralCategory = (n: number): ArabicPluralCategory => {
    if (!Number.isFinite(n) || !Number.isInteger(n)) return "other";
    const v = Math.abs(n);
    if (v === 0) return "zero";
    if (v === 1) return "one";
    if (v === 2) return "two";
    const m = v % 100;
    if (m >= 3 && m <= 10) return "few";
    if (m >= 11 && m <= 99) return "many";
    return "other";
};

/** Форма по числу; нужной формы нет — other. «{n}» в форме заменяется числом n (как есть). */
export const arPlural = (n: number, forms: ArabicPluralForms): string =>
    (forms[arabicPluralCategory(n)] ?? forms.other).replace("{n}", String(n));
